 <template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section v-for="collecte in listeCollecteDechet" :key="collecte.id">
                        <div class="Fiche" v-if="collecte.acf.type == 'Collecte Déchets' || collecte.acf.type == 'Déchetterie'">
                            <div class="Infos Contact">
                                <h4>{{collecte.acf.titre}}</h4>
                                <p class="paragraphe" v-html="collecte.acf.description"></p>
                                <div>
                                    <div v-if="collecte.acf.fichier_pdf_supplementaire != false" class="docuPDF">
                                        <iframe :src="collecte.acf.fichier_pdf_supplementaire" height="100%" width="100%"></iframe>
                                    </div>
                                    <p v-html="collecte.acf.legende"></p>
                                </div>
                            </div>
                            <div class="contenu-droit-page" v-if="collecte.acf.image != ''">
                                <iframe :src="collecte.acf.lien" height="100%" width="100%"></iframe>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Collecte-Dechet',
    data () {
        return{
            listeCollecteDechet:{
                id:0,
                acf:{
                    titre: null,
                    lien: null,
                    description: null,
                    fichier_pdf_supplementaire: null,
                    legende: null
                }
            }, 
            listeLieuCollecteDechet:{
                id: 0,
                acf:{
                    nom: null,
                    coordonnees_x: null,
                    coordonnees_y: null
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.hostacf+'collecte-dechet')
        .then(response =>{
            this.listeCollecteDechet = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Collectes des déchets et déchèteries'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Collecte-Dechet.vue